// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__1G6Oa","subheader":"ReorderModal_subheader__1BtWI","listWrap":"ReorderModal_listWrap__2jlGm"};